module.exports = __webpack_public_path__ + "img/recad.4e397bf3.jpg";